module.exports = __webpack_public_path__ + "img/business.4c93d575.png";